// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DialogTemplate_wrapper__3XPdo","card":"DialogTemplate_card__3b6HJ","closeButton":"DialogTemplate_closeButton__HLWUL","cardActions":"DialogTemplate_cardActions__2xDms"};